import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { speedCoachingProfileSchema } from '../schemas/speed-coaching-profile.schema';

/**
 * Requests the Speed Coaching Profiles associated with specific Vehicle Groups
 * @param ids The vehicle group IDs for the vehicle whose Speed Coaching Profiles are being requested
 * @returns The Speed Coaching Profiles
 */
export function getSpeedCoachingVehicleGroups(this: unknown, ids: number[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).speedCoachingVehicleGroupsUrl
        }?vehicleGroupIds=${ids.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(speedCoachingProfileSchema),
      })
    )
  );
}
